import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Link } from "react-router-dom";
import ReactTableFilterSelect from "helpers/react-table-filter-select";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";

import {
    fetchCountries,
    clearCountries
} from "actions/locations/actions";

class CountriesList extends React.Component {
    componentDidMount() {
        this.props.fetchCountries();
    }

    componentWillUnmount () {
        this.props.clearCountries();
    }

    render () {
        const { countries } = this.props;

        const classNameFlexCenter = "d-flex justify-content-center align-items-center";
        const columns = [
            {
                Header: "Name",
                accessor: "fullName",
                Cell: ({ original }) => (
                    <Link to={`/locations/${original.id}/provinces`}>{original.fullName}</Link>
                ),
                id: "fullName",
            },
            {
                Header: "Active?",
                id: "inactive",
                accessor: original => (original.inactive ? "NO" : "YES"),
                Cell: ({ original }) => (original.inactive ? "NO" : "YES"),
                className: classNameFlexCenter,
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "Active",
                            NO: "Inactive"
                        }}
                    />
                )
            },
            /* {
                Header: "Actions",
                id: "actions",
                Cell: ({ original }) => (
                    <ButtonGroup>
                        <Button size="sm" onClick={() => this.handleClick(original.id)}>
                            <FontAwesomeIcon icon="search" title="Search / Replace" />
                        </Button>
                    </ButtonGroup>
                ),
                getProps: () => ({
                    style: {
                        justifyContent: "space-between",
                        whiteSpace: "unset"
                    }
                }),
                filterable: false
            } */
        ];

        return (
            <div className="dashboard">
                <h3 className="mb-4">Countries</h3>

                <ReactTable
                    data={countries}
                    headerClassName="table-header"
                    columns={columns}
                    defaultPageSize={20}
                    pageSizeOptions={[10, 20, 50, 100]}
                    resizable
                    className="-striped -highlight"
                    loading={false}
                    filterable
                    defaultSorted={[
                        {
                            id: "fullName",
                            desc: false
                        }
                    ]}
                    defaultFiltered={[
                        {
                            id: "inactive",
                            value: "YES"
                        }
                    ]}
                    defaultFilterMethod={filterCaseInsensitive}
                    getNoDataProps = {() => ({
                        style: {
                            zIndex: 0
                        }
                    })}
                />
            </div>
        );
    }
}

CountriesList.propTypes = {
    fetchCountries: PropTypes.func.isRequired,
    clearCountries: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    countries: state.locations.countries
});

const mapStateToDispatch = dispatch => ({
    fetchCountries: bindActionCreators(fetchCountries, dispatch),
    clearCountries: bindActionCreators(clearCountries, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(CountriesList);



// WEBPACK FOOTER //
// ./src/views/pages/locations/countries-list.js